import React, {useEffect, useState} from 'react';
import {CommonServerSideParams} from '@/app/types/CommonServerSideParams';
import {OnlyBrowserPageProps} from '@/layouts/web/types/OnlyBrowserPageProps';
import {SSGPageProps} from '@/layouts/web/types/SSGPageProps';
import ReactDivWebMain from '@/modules/core/reactDivWeb/components/Web/Main/Main';
import WebLayout from '@/layouts/web/components/WebLayout';
import {
  // getWebLayoutStaticPaths,
  getWebLayoutStaticProps,
} from '@/layouts/web/webLayoutSSG';
// import useCustomer from '@/modules/core/data/hooks/useCustomer';
// import { Customer } from '@/modules/core/data/types/Customer';
import {createLogger} from '@/modules/core/logging/logger';
import {
  GetStaticPaths,
  GetStaticProps, GetStaticPropsResult,
  NextPage,
} from 'next';

import ReactDivWebAnnouncementTopBar from '@/modules/core/reactDivWeb/components/Announcements/TopBar/TopBar';

import {StaticPropsInput} from '@/app/types/StaticPropsInput';
import {getDashboardContentEditorLayoutStaticProps} from '@/layouts/dashboard/contentEditor/dashboardContentEditorLayoutSSG';
import {getReactDivApiConfig} from '@/modules/core/reactDivAPI/utils/getApiConfig';
import getSystemShellBySingularAPIID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShellBySingularAPIID';
import getShelledPageBySingularAPIID from '@/modules/core/reactDivAPI/utils/queries/web/getShelledPageBySingularAPIID';
import deepmerge from 'deepmerge';
import getClientProjectContentBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/web/getClientProjectContentBySystemShellID';
import getSystemShelledFieldsBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShelledFieldsBySystemShellID';
import Annoucement from "@/components/centralbrisbanedental/Announcement";
import Topbar from "@/components/centralbrisbanedental/Topbar";
import NavBar from "@/components/centralbrisbanedental/NavBar/NavBar";
import Hero from "@/components/centralbrisbanedental/Hero/Hero";
import AppointmentRequestForm
  from "@/components/centralbrisbanedental/userActions/AppointmentRequestForm/AppointmentRequestForm";
import CTABannerStandard from "@/components/centralbrisbanedental/CTABannerStandard/CTABannerStandard";
import CTABannerImageDescriptive
  from "@/components/centralbrisbanedental/CTABannerImageDescriptive/CTABannerImageDescriptive";
import CTABannerSplitTiles from "@/components/centralbrisbanedental/CTABannerSplitTiles/CTABannerSplitTiles";
import TwoColumnContent from "@/components/centralbrisbanedental/TwoColumnContent/TwoColumnContent";
import ContentBackgroundImage from "@/components/centralbrisbanedental/ContentBackgroundImage/ContentBackgroundImage";
import Footer from "@/components/centralbrisbanedental/Footer/Footer";
import PageHeader from "@/components/centralbrisbanedental/page/Header/Header";
import FAQ from "@/components/centralbrisbanedental/FAQ/FAQ";
import Callout from "@/components/centralbrisbanedental/Callout";
import Tabs from "@/components/centralbrisbanedental/Tabs/Tabs";


const fileLabel = 'pages/index';
const logger = createLogger({ // eslint-disable-line no-unused-vars,@typescript-eslint/no-unused-vars
  fileLabel,
});

/**
 * Only executed on the server side at build time.
 * Necessary when a page has dynamic routes and uses "getStaticProps".
 */
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths({fallback:true});
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths();

/**
 * Only executed on the server side at build time.
 *
 * @return Props (as "SSGPageProps") that will be passed to the Page component, as props.
 *
 * @see https://github.com/vercel/next.js/discussions/10949#discussioncomment-6884
 * @see https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 */
export const getStaticProps: GetStaticProps<SSGPageProps, CommonServerSideParams> = async (props: StaticPropsInput): Promise<GetStaticPropsResult<SSGPageProps>> => {
  const commonStaticProps: GetStaticPropsResult<SSGPageProps> = await getWebLayoutStaticProps()(props);
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('getStaticProps commonStaticProps', commonStaticProps); // eslint-disable-line no-console
  }
  if ('props' in commonStaticProps) {
    const config = getReactDivApiConfig();

    const [
      // Below is Web Module
      // currentShelledPage,
      // currentClientProjectSEOSettings,
      // currentShelledPageSeoSettings, // NOTE This is a dependency, should loop through these
      // currentClientProjectSEOSettings,
      // Above is Web Module
    ] = await Promise.all([
      // Below is Web Module
      // getShelledPageBySingularAPIID({config, slug: 'home'}),
      // getSystemShelledFieldsBySystemShellID({config, systemShellID: '630f756db23725aedbc16e7d'}),
      // getClientProjectContentBySystemShellID({
      //   config,
      //   clientID: commonStaticProps.props.reactDivClientID,
      //   projectID: commonStaticProps.props.reactDivClientProjectID,
      //   systemShellID: '630f756db23725aedbc16e7d',
      // }),
      // getBySingularAPIID({config, slug: "home"}),
      // Above is Web Module
    ]);

    return deepmerge(commonStaticProps, {
      props: {
        // Below is Web Module
        // currentShelledPage,
        // currentShelledPageSeoSettings,
        // currentClientProjectSEOSettings,
        // Above is Web Module
        builtAt: new Date().toISOString(),
      },
      // revalidate: regenerationDelay,
    });
    // return commonStaticProps;
  } else {
    return commonStaticProps;
  }
};

/**
 * SSG pages are first rendered by the server (during static bundling).
 * Then, they're rendered by the client, and gain additional props (defined in OnlyBrowserPageProps).
 * Because this last case is the most common (server bundle only happens during development stage), we consider it a default.
 * To represent this behaviour, we use the native Partial TS keyword to make all OnlyBrowserPageProps optional.
 *
 * Beware props in OnlyBrowserPageProps are not available on the server.
 */
type Props = {} & SSGPageProps<Partial<OnlyBrowserPageProps>>;

let invisibleBracesContentA: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'There is more than one way to do everything ' +
              'in life.  The end result is the same, but the pathway to get to the end may be very different.  Pathways may be different in lengths, taking varying durations to reach the end, and there may be obstacles along the way which make a particular pathway harder to travel.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'The same principles apply to straightening ' +
              'your teeth.  Modern orthodontics allow us to straighten teeth using many different methods.  The end result is straighter teeth, but some methods are quicker than others.  Some methods are not as aesthetic, comfortable, cleansable or socially acceptable while treatment is progressing.  If you’re thinking about getting invisible braces then you are probably concerned about how you may look with metal braces in your mouth.  That’s totally fine.  Invisible braces are a great option for straightening teeth while keeping things less noticeable.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/invisible-toothy-invisible-braces.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]
let invisibleBracesContentB: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'The traditional pathway of straightening ' +
              'teeth is to use metal brackets and wires, called braces, to align all the teeth.  This generally takes at least 12 months with major patient hesitations being the visible metal brackets and wires, dubbed “train-tracks”, which are considered unsightly, uncomfortable and hard to clean.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'This led to the development of a more ' +
              'modern pathway of using a sequence of clear aligners to straighten all the teeth, commonly referred to as “invisible braces”.  These clear aligners are actually nothing like the metal brackets and wires which we picture in our minds when the word braces are mentioned.  They are nicknamed “invisible braces” because they do the teeth straightening job that traditional braces do but do it in a more incognito way.  The aligners are virtually invisible when worn over the teeth as they are thin and clear.  It generally may still take at least 12 months to align all the teeth, but aligners are more socially acceptable and much less intrusive on eating, cleaning and smiling.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'heading',
            type: 'h3',
            value: 'Is Invisible Really Better?',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontWeight: "bold",
              fontSize: "text-2xl",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'When it comes to straightening teeth, it ' +
              'really is better.  There are many reasons why aligners are the preferred method for teeth straightening by both dentists and patients:',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'richList',
            type: 'ul',
            value: [
              "They are clear and virtually invisible",
              "They are removable for easier eating and cleaning",
              "They are thinner and more comfortable",
              "There are less breakages",
              "There is better patient compliance",
              "Precise computer analysis and manufacturing",
              "Can accurately follow movements provided by each aligner"
            ]
          }
        ]
      },
    ]
  },
]
let invisibleBracesContentC: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Some patients are after a quicker fix and ' +
              'don’t want all their teeth aligned, only their visible front teeth.  This has led to the same “invisible braces” concept being adapted to treatment of only the front 6 teeth.  Front teeth can be straightened the incognito way using clear aligners or other nearly invisible removable appliances.  Some cases require brackets and wires to move the front teeth effectively and this can be done with clear brackets and tooth coloured wires.  Because only the front teeth are treated, the cost and time required for this orthodontic treatment is reduced.  This is commonly referred to as 6 month braces.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'If you choose to straighten all your teeth, ' +
              'our dentists will provide aligner orthodontics through Clearpath.  You can learn more about aligner orthodontics on this page.  If you are interested in a quicker solution that corrects your front teeth only then we will provide that treatment through Quick Straight Teeth.  You can learn more about Quick Straight Teeth on this page.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/aligner-orthodontics.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]

/**
 * Example of a public page.
 */
const Index: NextPage<Props> = (props): JSX.Element => {
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('Index props', props); // eslint-disable-line no-console
  }
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    };
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <>
      <div className="sticky top-0 z-10 shadow-md">
        <Annoucement
          mobilePrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          desktopPrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          tailwindWrapperClassNames={{
            tailwind: "bg-[#400068]"
          }}
          tailwindContainerClassNames={{
            tailwind: "mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between"
          }}
          destination="/static/pdf/case-study-dr-wan.pdf"
        />
        <Topbar
          scrollY={scrollY}
          style={{
            background: "bg-[#f3f3f3]"
          }}
        />
      </div>
      <NavBar />
      <PageHeader
        title="Invisible Braces"
        background="bg-[#400068]"
        backgroundImage="/static/images/headers/life-cycle-header-overlay.png"
      />
      <main>
        <TwoColumnContent
          title="Less Visibility, Same End Result!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={invisibleBracesContentA}
        />
        <Callout
          mobilePrimaryTextValue="More information about invisible braces"
          desktopPrimaryTextValue="More information about invisible braces"
          iconColour={"#400068"}
          textClassNames={{
            colour: "text-black"
          }}
          tailwindWrapperClassNames={{
            tailwind: "bg-[#17AAAB]"
          }}
          tailwindContainerClassNames={{
            tailwind: "mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between"
          }}
          destination="/static/pdf/Central-Brisbane-Dental-Aligner-Orthodontics.pdf"
        />
        <Tabs
          wrapperClassNames={{
            background: "bg-[#400068]"
          }}
          containerClassNames={{
            spacing: "container mx-auto",
            padding: "py-8"
          }}
          heading="Invisible Braces"
          headingClassNames={{
            fontSize: "text-2xl md:text-3xl",
            fontWeight: "font-bold",
            color: "text-white",
            padding: "py-4 px-4 md:px-0",
            alignment: "text-center md:text-left"
          }}
          headingEmphasis="Procedure and Cost"
          headingEmphasisClassNames={{
            color: "text-[#ff6600]"
          }}
          tabs={[
            {
              heading: "30 Minute Appointment – Free Cosmetic Consult",
              items: [
                {
                  heading: "Item 015 - Long Consultation",
                  content: [
                    `<strong>Description:</strong> Evaluation of teeth crowding and spacing, the bite and if appropriate for clear aligner orthodontic treatment`,
                    `<strong>Cost:</strong> Free, normally $66.`
                  ]
                },
                {
                  heading: "Additional Steps",
                  content: [
                    `Give referral form to X-ray Clinic to get OPG and Lat Ceph (full mouth and side profile 2D scans, bulk billed or subsidised by Medicare) - some practices charge $200 or more for these, we refer out as it is cheaper for the patient with Medicare coverage - Comprehensive evaluation of the teeth, jaw bone and side profile.`
                  ]
                }
              ]
            },
            {
              heading: "1 Hour Appointment – Record Taking to Produce Treatment Plan and Aligners",
              items: [
                {
                  heading: "Item 825 x2 - Clear Aligner Treatment Upper and Lower Teeth",
                  content: [
                    `<strong>Description:</strong> Includes record taking and analysis, treatment plan with before and
                      projected after images, all orthodontic review appointments, all aligners and a set of retainers.`,
                    `<strong>Cost:</strong> $2599 to $6000 depending on complexity of case and number of aligners needed.`
                  ]
                },
                {
                  heading: "Item 015 Long Consultation",
                  content: [
                    `<strong>Description:</strong> Orthodontic assessment and analysis of impressions and x-ray and
                    photographic records.`,
                    `<strong>Cost:</strong> no extra charge, normally $66.`
                  ]
                },
                {
                  heading: "Item 071 x2 Impressions of Upper and Lower Teeth",
                  content: [
                    `<strong>Description:</strong> Impressions of Upper and Lower Teeth.`,
                    `<strong>Cost:</strong> no extra charge, normally $180.`
                  ]
                },
                {
                  heading: "Item 072 Intraoral Photographic Records",
                  content: [
                    `<strong>Description:</strong> Intraoral Photographic Records.`,
                    `<strong>Cost:</strong> no extra charge, normally $90.`
                  ]
                },
                {
                  heading: "Item 073 Extraoral Photographic Records",
                  content: [
                    `<strong>Description:</strong> Extraoral Photographic Records.`,
                    `<strong>Cost:</strong> no extra charge, normally $90.`
                  ]
                }
              ]
            },
            {
              heading: "30 Minute Appointment - Discussion of Treatment Plan",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Discussion of Treatment Plan With Before and Projected After Images.`,
                    `<strong>Cost:</strong> no extra charge, normally $66.`
                  ]
                }
              ]
            },
            {
              heading: "30 Minute Appointment - Insertion of 1st Aligners",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Insertion of 1st Aligners and Discussion About Use.`,
                    `<strong>Cost:</strong> no extra charge, normally $66.`
                  ]
                }
              ]
            },
            {
              heading: "Regular 15 - 30 Minute Appointments",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Review of Aligner Progression, Adjustments as Needed.`,
                    `<strong>Cost:</strong> no extra charge, normally $66 per appointment.`
                  ]
                }
              ]
            },
            {
              heading: "Regular 15 Appointment - Insertion of Retainers",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Insertion of Retainers Once Aligner Treatment is Complete.`,
                    `<strong>Cost:</strong> no extra charge, normally $66 per appointment.`
                  ]
                }
              ]
            },
          ]}
        />
        <CTABannerImageDescriptive
          imageProperties={{
            layout: 'intrinsic',
            alt: 'happy toothy character',
            type: 'dimensions',
            src: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
            height: 285,
            width: 412.5,
          }}
          title="Philips Zoom"
          heading="Teeth Whitening for just $660!"
          description="Come in for a free consultation."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          imageClasses={{
            textAlign: "center",
            padding: "p-5"
          }}
          titleClasses={{
            dynamicColour: '#ff6600',
            fontSize: 'text-base',
            fontWeight: 'semibold',
            letterSpacing: 'tracking-wider',
            uppercase: true,
          }}
          headingClasses={{
            margin: 'mt-2',
            fontSize: 'text-2xl sm:text-3xl',
            fontWeight: 'extrabold',
            letterSpacing: 'tracking-tight',
            colour: 'text-white',
          }}
          descriptionClasses={{
            margin: 'mt-3',
            fontSize: 'text-lg',
            colour: 'text-white'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#070707',
          }}
        />
        <FAQ
          enableHeading={true}
          faqs={[
            {
              question: "What are invisible braces?",
              answer: "Invisible braces are just another commonly used term to refer to aligner orthodontics or teeth straightening using a series of clear aligners.  Some people think of invisible braces as Invisalign.  However, Invisalign is actually just one brand of clear aligners used to straighten teeth.  In the past, teeth straightening was done with traditional braces, made from metal wires and brackets. Although effective, these braces are obviously very noticeable.  Patients demanded a less noticeable option and hence, clear aligners were developed.  Many cases of teeth straightening can be performed with clear aligners.  These days, clear aligners are in many cases just as effective as traditional braces.  Some complex teeth straightening may require brackets and wires braces.  Even these cases, sometimes use clear aligners to do some movements together with traditional braces."
            },
            {
              question: "Can I get Invisalign?",
              answer: "Invisalign is just a commonly known brand of clear aligners.  At Central Brisbane Dental we prefer to use ClearPath as our choice of clear aligners.  ClearPath aligners have a patented micro criss-cross pattern which allows their aligners to better grip your teeth and move them.  This avoids the need for the dentist to glue little bits of composite resin filling material to your teeth to support the aligners, which is a common need with other brands like Invisalign.  These bits of filling material don’t look good, are harder to clean and can break away and need replacing.  These are not needed with ClearPath aligners and that is the main reason we prefer to use ClearPath aligners."
            },
            {
              question: "What type of braces work the fastest?",
              answer: "These days there is not much difference in treatment duration between traditional metal braces and clear aligners or invisible braces.  The main reasons for choosing clear aligners over traditional braces is not the speed of treatment but because they are much less conspicuous and allows easier oral hygiene and eating.\n" +
                "The complexity of the case determines how long the duration of treatment.  If you have a very mild case that requires very few aligners to complete teeth straightening, your whole treatment with clear aligners could be as short as 12 weeks.  Most cases are moderate cases and are completed within a year.  Expect treatment for severe cases to be for more than one year."
            },
            {
              question: "How much do invisible braces cost?",
              answer: "The cost of invisible braces is directly related to the complexity of the teeth straightening you require and the number of aligners needed to treat your case.  If you have fairly minor teeth crowding or spacing, you may only require a few aligners to correct this, and the cost starts at $2599. If you have severe teeth crowding or spacing, you will need many aligners to correct this, and the cost may be up to $6000. We allow patients to pay 50% upfront and pay off the remaining balance over the course of their treatment.\n" +
                "If you want to get a better idea of the costs for your case, take advantage of our free cosmetic consultation which will allows us to review your teeth and come up with a cost and treatment plan for straightening your teeth.  Terms and Conditions."
            }
          ]}
        />
        <TwoColumnContent
          title="Getting Straight Teeth The Incognito Way!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={invisibleBracesContentB}
        />
        <CTABannerSplitTiles
          dentist="vincent"
          heading="Did you know?"
          value="You can get 2 checkup and cleans a year for $0 or a very small out-of-pocket when you come and see us and use your health fund."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          hasInset={true}
          insetClasses={{
            display: 'hidden lg:block',
            position: 'absolute top-0 inset-x-0',
            height: 'h-1/2',
            dynamicBackground: '#400068'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#fff',
            padding: 'py-16'
          }}
        />
        <TwoColumnContent
          title="Let's Give You Some Clearer Options!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={invisibleBracesContentC}
        />
        {/* Content Layout Two - Repeated */}
        <section
          data-component-type="content-only"
        >

          <div
            className="container mx-auto flex"
          >

            <div className="w-full flex justify-end py-8">

              <div className="flex flex-col justify-center px-2">

                <h2 className="mt-2 text-black text-3xl font-extrabold tracking-tight sm:text-4xl text-center">
                  Free Orthodontic Consult Regarding <span className="text-[#17aaab]">Invisible Braces</span>:
                </h2>

                <p className="mt-5 text-lg text-gray-900 mr-8">
                  Come to our Brisbane CBD dental clinic for a free 30 minute orthodontic consult regarding invisible
                  braces*. One of our Brisbane CBD dentists will perform a dental checkup and give you customised options specific to your teeth and case. We will have an in depth discussion about straight teeth and teeth straightening. You will know whether invisible braces with clear aligners is suitable. You will know whether invisible braces with clear brackets and white coloured wires is an option. We will also discuss referral to a specialist orthodontist if this is more appropriate for your case. We will provide you with a treatment plan with dental item numbers to check coverage with your health fund if you have health insurance. We are preferred providers for many health funds, including CBHS, HCF, nib, Australian Unity, AIA Health Insurance, Peoplecare, health.com.au, Frank, GMHBA, My Own Health Insurance and Healthcare Insurance, so you can receive a dental checkup and clean every 6 months for no gap payment or a small gap payment. View Terms and Conditions..  You will know the exact cost of invisible braces provided by our Brisbane CBD dental clinic and anything else you may need and their prices. Most patients are pleasantly surprised by the affordability of the invisible braces cost in the Brisbane CBD and the flexibility of our payment plan options. Invisible braces in Australia can be quite cheap and affordable. You can review this treatment plan at your leisure and ask your dentist any questions you may have before proceeding. We can also provide a referral form to a x-ray clinic to get specific orthodontic treatment x-rays, usually an OPG and a Lat Ceph, for further assessment.  These x-rays are bulk billed by Medicare if you have a Medicare card. You can book your free orthodontic consult by calling us on 3221 8816 or online by filling out our contact request form. View Terms and Conditions.
                </p>

              </div>

            </div>

          </div>

        </section>
      </main>
      <Footer />
    </>
  );
};

export default Index;
